module.exports = __webpack_public_path__ + "img/photographer.bcc39a4e.jpg";